import React, { useContext } from 'react'
import { PATIENT_DATE_FILTER_OPTIONS } from 'app/constants'
import { useIntl } from 'hooks'
import { IntlContext } from 'features/multilingual'
import { Select, Radio, Datepicker, ToggleSwitch } from 'components/Form'
import './index.css'

const PatientFilter = ({ values, tags, ...formik }) => {
    const context = useContext(IntlContext)
    const { t } = useIntl()

    return (
        <>
            <Radio name="date" label={t('exam.date')} options={PATIENT_DATE_FILTER_OPTIONS} />
            <div className="filter-custom-date">
                <Datepicker
                    name="dateFrom"
                    noLabel
                    max={new Date()}
                    disabled={values.date !== 'custom'}
                    locale={context.locale}
                />
                <Datepicker
                    name="dateTo"
                    noLabel
                    max={new Date()}
                    disabled={values.date !== 'custom'}
                    locale={context.locale}
                />
            </div>
            <Select
                name="tag"
                multiple
                label={t('label.tags')}
                options={tags}
                onChange={e => {
                    const v = e.target.value
                    if (v.length > 1 && v.includes('all')) {
                        const index = v.indexOf('all')
                        if (index === 0) {
                            formik.setFieldValue(
                                'tag',
                                e.target.value.filter(t => t !== 'all')
                            )
                        } else {
                            formik.setFieldValue('tag', ['all'])
                        }
                    } else {
                        formik.setFieldValue('tag', e.target.value)
                    }
                    formik.setFieldTouched('tag')
                }}
            />
            <ToggleSwitch label="Shared files only" name="shared" />
        </>
    )
}

export default React.memo(PatientFilter)
